'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.beginTask = beginTask;
exports.endTask = endTask;

var _constants = require('./constants');

var ActionTypes = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function beginTask() {
  return {
    type: ActionTypes.BEGIN_TASK
  };
}

function endTask() {
  return {
    type: ActionTypes.END_TASK
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-nprogress/lib/actions.js
// module id = 386
// module chunks = 2